import { Component, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { IonSpinner } from '@ionic/angular/standalone';
import { AsyncPipe } from '@angular/common';
import { Observable } from 'rxjs';
import { isLoading } from '@app/app/core/store/selectors/layout.selectors';

@Component({
  selector: 'app-loader',
  standalone: true,
  imports: [IonSpinner, AsyncPipe],
  template: `
    @if(isLoading$ | async) {
    <div class="loader-overlay">
      <ion-spinner name="crescent"></ion-spinner>
    </div>
    }
  `,
  styles: [
    `
      .loader-overlay {
        position: fixed;
        inset: 0;
        background: rgba(0, 0, 0, 0.35);
        backdrop-filter: blur(4px);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 99999;
      }
    `,
  ],
})
export class AppLoaderComponent {
  private store = inject(Store);
  isLoading$: Observable<boolean> = this.store.select(isLoading);
}
